import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between gap-8 px-6 py-3 border border-gray-lp-1400 rounded-md" }
const _hoisted_2 = { class: "flex items-center gap-x-4 w-3/4" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-lp-100 text-14px flex items-center gap-x-1.5 p-2.5 bg-red-lp-1300 whitespace-nowrap rounded-md"
}
const _hoisted_4 = {
  key: 1,
  class: "text-yellow-lp-500 text-14px flex items-center gap-x-1.5 p-2.5 bg-yellow-lp-400 whitespace-nowrap rounded-md"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Terjadi perubahan data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_PopupDimensionPerKoli = _resolveComponent("PopupDimensionPerKoli")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          label: _ctx.$t('Total koli aktual'),
          class: "w-1/3",
          value: _ctx.summary.totalPieces
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          label: _ctx.$t('Total berat kotor aktual'),
          class: "w-1/3",
          value: `${_ctx.formatNumberToString(_ctx.summary.actualGrossWeight)} kg`
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          fontSize: 14,
          label: _ctx.$t('Total berat volume aktual'),
          class: "w-1/3",
          value: `${_ctx.formatNumberToString(_ctx.summary.actualVolumeWeight)} kg`
        }, null, 8, ["label", "value"])
      ]),
      (_ctx.errorSummary)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_Icons, {
              name: "warning-circle",
              class: "w-6"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.errorSummary), 1)
          ]))
        : (_ctx.isSttUpdated)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Icons, {
                name: "warning-circle",
                class: "w-6"
              }),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_lp_button, {
        id: "button_change_dimension_create_booking_cargo",
        title: "Ubah",
        outline: "",
        textColor: "red-lp-100",
        iconLeft: "icon-edit-dash",
        onClick: _ctx.onEdit
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_PopupDimensionPerKoli, {
      isEdit: _ctx.isEdit,
      modelValue: _ctx.editDimensionPerKoli,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editDimensionPerKoli = $event))
    }, null, 8, ["isEdit", "modelValue"])
  ], 64))
}